if (!window.customElements.get('collection-carousel')) {

    class CollectionCarousel extends HTMLElement {
        constructor() {
            super();
            this.slider = null;
            this.hasInitialized = false;
            this.isAtStart = true;
            this.isAtEnd = false;
        }

        connectedCallback() {
            const sliderContainer = this.querySelector('.keen-slider');
            if (!sliderContainer || sliderContainer.children.length < 2) return;

            // Add smooth transitions to the arrow
            const arrow = this.querySelector('.keen-slider__arrow--cursor');
            if (arrow) {
                arrow.style.transition = 'opacity 0.3s ease-in-out, visibility 0.3s ease-in-out';
            }

            whenReady('KeenSlider', () => {
                try {
                    this.initializeSlider(sliderContainer);
                } catch (error) {
                    console.error('Failed to initialize KeenSlider:', error);
                }
            });
        }

        initializeSlider(container) {
            const arrow = this.querySelector('.keen-slider__arrow--cursor');
            let isInNavigationZone = false;

            // Wheel Controls function (from Keen Slider example)
            const WheelControls = (slider) => {
                let touchTimeout;
                let position;
                let wheelActive;
                let isHorizontalScroll = false;

                function dispatch(e, name) {
                    position.x -= e.deltaX;
                    position.y -= e.deltaY;
                    slider.container.dispatchEvent(
                        new CustomEvent(name, {
                            detail: {
                                x: position.x,
                                y: position.y,
                            },
                        })
                    );
                }

                function wheelStart(e) {
                    position = {
                        x: e.pageX,
                        y: e.pageY,
                    };
                    dispatch(e, "ksDragStart");
                }

                function wheel(e) {
                    dispatch(e, "ksDrag");
                }

                function wheelEnd(e) {
                    dispatch(e, "ksDragEnd");
                }

                function eventWheel(e) {
                    // Check if this is primarily a horizontal scroll
                    const isHorizontal = Math.abs(e.deltaX) > Math.abs(e.deltaY);
                    
                    // If it's a horizontal scroll or we're already in an active horizontal scroll
                    if (isHorizontal || wheelActive) {
                        if (isHorizontal) {
                            e.preventDefault();
                            e.stopPropagation();
                            if (!wheelActive) {
                                wheelStart(e);
                                wheelActive = true;
                                isHorizontalScroll = true;
                            }
                            wheel(e);
                            clearTimeout(touchTimeout);
                            touchTimeout = setTimeout(() => {
                                wheelActive = false;
                                isHorizontalScroll = false;
                                wheelEnd(e);
                            }, 50);
                        }
                        
                    }
                }

                slider.on("created", () => {
                    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
                    if (!isSafari) {
                        slider.container.addEventListener("wheel", eventWheel, {
                            passive: false,
                        });
                    }
                });
            };

            // Progress nav logic
            const progressNav = this.querySelector('.keen-slider__progress-nav');
            const progressBar = progressNav ? progressNav.querySelector('.keen-slider__progress-bar') : null;
            const slides = container.querySelectorAll('.keen-slider__slide');
            const slidesInView = window.innerWidth > 991 ? 4 : window.innerWidth > 767 ? 3 : 1;

            // Add click handler to progress nav
            if (progressNav) {
                progressNav.addEventListener('click', (e) => {
                    if (!this.slider) return;
                    
                    // Get the click position within the nav
                    const rect = progressNav.getBoundingClientRect();
                    const clickX = e.clientX - rect.left;
                    const clickPercentage = clickX / rect.width;
                    
                    // Calculate the target slide index based on click position
                    const maxIdx = this.slider.track.details.maxIdx;
                    const targetSlideIndex = Math.floor(clickPercentage * maxIdx);
                    
                    // Ensure we don't exceed the maximum index
                    const clampedIndex = Math.min(targetSlideIndex, maxIdx);

                    console.log(clampedIndex);
                    
                    // Move to the target slide
                    this.slider.moveToIdx(clampedIndex);
                });
            }

            // Update progress bar position
            const updateProgressBar = (relIdx) => {
                if (!progressBar) return;
                
                // Use the slider's maxIdx instead of slides.length to account for placeholders
                const maxIdx = this.slider ? this.slider.track.details.maxIdx : slides.length - slidesInView;
                const isAtEnd = relIdx >= maxIdx;
                
                // Calculate progress percentage
                const progressPercentage = isAtEnd ? 100 : (relIdx / maxIdx) * 100;
                
                // Get the progress nav container to calculate available width
                const progressNavWidth = progressNav.offsetWidth + 8;
                const barWidth = window.innerWidth > 991 ? 235 : 85;
                const maxTranslateX = progressNavWidth - barWidth; // Maximum translation
                
                // Calculate the translateX position
                const translateX = (progressPercentage / 100) * maxTranslateX;
                
                // Update the progress bar position
                if (window.gsap) {
                    window.gsap.to(progressBar, { 
                        x: translateX, 
                        duration: 0.3, 
                        ease: "expo.out" 
                    });
                } else {
                    progressBar.style.transform = `translateX(${translateX}px)`;
                    progressBar.style.transition = 'none';
                    progressBar.style.opacity = '1';                    
                }
            };

            const sliderConfig = {
                loop: false,
                rubberband: false,
                slides: {
                    perView: "auto",
                    spacing: 16
                },
                defaultAnimation: {
                    duration: 1000,
                    easing: (t) => {
                        return 1 - Math.pow(1 - t, 7);
                    }
                },  
                dragSpeed: 1.2,
                dragAngle: 45,
                created(s) {
                    // Ensure slides are properly sized
                    // s.slides.forEach(slide => {
                    //     slide.style.flex = '0 0 auto';
                    // });
                    
                    // Prevent vertical scrolling during touch interactions
                    s.container.addEventListener('touchstart', (e) => {
                        if (e.touches.length === 1) {
                            const touch = e.touches[0];
                            s.container._touchStartY = touch.clientY;
                            s.container._touchStartX = touch.clientX;
                        }
                    }, { passive: true });
                    
                    s.container.addEventListener('touchmove', (e) => {
                        if (e.touches.length === 1 && s.container._touchStartY !== undefined) {
                            const touch = e.touches[0];
                            const deltaY = Math.abs(touch.clientY - s.container._touchStartY);
                            const deltaX = Math.abs(touch.clientX - s.container._touchStartX);
                            
                            // If horizontal movement is greater than vertical, prevent vertical scroll
                            if (deltaX > deltaY && deltaX > 10) {
                                e.preventDefault();
                            }
                        }
                    }, { passive: false });
                    
                    s.container.addEventListener('touchend', (e) => {
                        delete s.container._touchStartY;
                        delete s.container._touchStartX;
                    }, { passive: true });
                },
                detailsChanged: (s) => {
                    this.isAtStart = s.track.details.rel === 0;
                    this.isAtEnd = s.track.details.rel === s.track.details.maxIdx;
                    this.handleSlideChange(s, container);
                    updateProgressBar(s.track.details.rel);
                }
            };

            this.slider = new window.KeenSlider(container, sliderConfig, [WheelControls]);

            // Initialize progress nav on first load
            updateProgressBar(0);

            // Handle mouse movement
            const updateArrowPosition = (e) => {
                const rect = container.getBoundingClientRect();
                const x = e.clientX - rect.left;
                const y = e.clientY - rect.top;
                const quarter = Math.floor(x / (rect.width / 4));
                let showArrow = false;
                let rotate = 0;
                isInNavigationZone = false;

                if (quarter === 0 && !this.isAtStart) {
                    showArrow = true;
                    rotate = 180;
                    isInNavigationZone = true;
                } else if (quarter === 3 && !this.isAtEnd) {
                    showArrow = true;
                    rotate = 0;
                    isInNavigationZone = true;
                }

                // Position the arrow relative to the slider container
                arrow.style.left = `${x}px`;
                arrow.style.top = `${y}px`;
                arrow.style.transform = `rotate(${rotate}deg)`;

                if (showArrow) {
                    arrow.style.visibility = 'visible';
                    arrow.style.opacity = '1';
                } else {
                    arrow.style.visibility = 'hidden';
                    arrow.style.opacity = '0';
                }
            };

            const hideArrow = () => {
                arrow.style.visibility = 'hidden';
                arrow.style.opacity = '0';
                isInNavigationZone = false;
            };

            container.addEventListener('mousemove', updateArrowPosition, { passive: true });
            container.addEventListener('mouseleave', hideArrow);

            // Prevent link clicks in navigation zones
            container.addEventListener('click', (e) => {

                if(window.matchMedia('(hover: none)').matches) {
                    return;
                }

                const rect = container.getBoundingClientRect();
                const x = e.clientX - rect.left;
                const quarter = Math.floor(x / (rect.width / 4));
                if (quarter === 0 && !this.isAtStart) {
                    e.preventDefault();
                    this.slider.prev();
                } else if (quarter === 3 && !this.isAtEnd) {
                    e.preventDefault();
                    this.slider.next();
                }
                // Otherwise, allow normal link clicks
            }, true);

            // Add support for external arrow buttons
            const prevArrow = this.querySelector('.keen__slider-arrow-prev');
            const nextArrow = this.querySelector('.keen__slider-arrow-next');
            if (prevArrow) {
                prevArrow.addEventListener('click', (e) => {
                    e.preventDefault();
                    if (this.slider) this.slider.prev();
                });
            }
            if (nextArrow) {
                nextArrow.addEventListener('click', (e) => {
                    e.preventDefault();
                    if (this.slider) this.slider.next();
                });
            }

            if (!this.hasInitialized) {
                this.hasInitialized = true;

                setTimeout(() => {
                    container.classList.add("keen-slider--initialized")
                }, 300);

            }
        }

        handleSlideChange(slider, container) {
            // container.classList.add("keen-slider--initialized");
            
            // Update slide states
            slider.slides.forEach((element, idx) => {
                const portion = slider.track.details.slides[idx].portion;
                // element.classList.toggle('keen-slider__slide--active', portion === 1);
            });
        }

        disconnectedCallback() {
            if (this.slider) {
                this.slider.destroy();
                this.slider = null;
            }
            this.hasInitialized = false;
        }
    }

    window.customElements.define('collection-carousel', CollectionCarousel);
    
}